import { transparentColors } from '@/assets/styles/helpers/colors.styles'

export const skeletonStyles = {
  backgroundColor: transparentColors.whiteShade3
}
